import PhoneNumber from '~/components/PhoneNumber';
import { PhoneNumberHeaderStyled } from './PhoneNumberStyled';
import React, { useContext } from 'react';
import { FuelContext } from '~/providers/FuelProvider';
import { trackEvent } from '~/helpers/tracking';
import { useSelector } from 'react-redux';
import { ReduxState } from '~/types/redux';
import useInViewport from '~/hooks/useInViewport';

const PhoneNumberHeader = (): JSX.Element => {
  const { callInNumber, monarch } = useSelector((store: ReduxState) => store);
  const { router } = useContext(FuelContext);
  const { pathname } = router;
  const currentPage = pathname === '/' ? 'address-check' : router.route.slice(1);
  const { cartShowDuringOfficeHours } = monarch;

  const handleCallButton = () => {
    trackEvent({
      action: 'elementClicked',
      data: {
        elementType: 'BUTTON',
        location: currentPage,
        position: 'header',
        text: 'call button ' + callInNumber,
      },
    });
  };
  const { ref } = useInViewport(0, true, () => {
    trackEvent({
      action: 'elementViewed',
      data: {
        elementType: 'BUTTON',
        location: currentPage,
        position: 'header',
        text: 'call button',
      },
    });
  });

  const hidePhone =
    !cartShowDuringOfficeHours &&
    (monarch?.cartHidePhoneUniversal ||
      monarch?.cartHideOnServiceability ||
      monarch?.cartHideOnProductSelection ||
      monarch?.cartHideOnContactCredit ||
      monarch?.cartHideAfterContactCredit);

  if (hidePhone) {
    return null;
  }

  return (
    <PhoneNumberHeaderStyled ref={ref}>
      <p>Need help?</p>
      <PhoneNumber number={callInNumber} aria-labelledby="Contact Frontier" onClick={handleCallButton} />
    </PhoneNumberHeaderStyled>
  );
};

PhoneNumberHeader.displayName = 'Header';
export default PhoneNumberHeader;
